import { createSlice } from '@reduxjs/toolkit';
import { getAllShowrooms } from '../api/showrooms';

export const showroomSlice = createSlice({
  name: 'showroom',
  initialState: {
    loading: false,
    error: {},
    showrooms: {},
  },
  reducers: {
    clearShowroomError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllShowrooms.pending]: (state) => {
      state.loading = true;
    },
    [getAllShowrooms.fulfilled]: (state, action) => {
      state.loading = false;
      state.showrooms = action.payload;
      state.error = {};
    },
    [getAllShowrooms.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearShowroomError } = showroomSlice.actions;

export default showroomSlice.reducer;
